import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'app/app.constants';
import { IObserverTimeline } from 'app/shared/model/FDEObserverService/observer.model';

@Injectable({ providedIn: 'root' })
export class ObserverService {
    public resourceUrl = SERVER_API_URL + 'api/v2/observer/timeline';
    public frameUrl = SERVER_API_URL + 'api/v2/observer/frame';
    public bundleUrl = SERVER_API_URL + 'api/v2/observer/frames/bundle';

    constructor(protected http: HttpClient) {}

    bundle(runner: string, account: string, executionId: string, from: number, count: number): Observable<ArrayBuffer> {
        const params = new HttpParams()
            .set('runner', runner)
            .set('account', account)
            .set('executionId', executionId)
            .set('from', String(from))
            .set('count', String(count));
        return this.http.get(this.bundleUrl, { params, responseType: 'arraybuffer' });
    }

    frame(runner: string, account: string, executionId: string, seq: number): Observable<Blob> {
        const params = new HttpParams()
            .set('runner', runner)
            .set('account', account)
            .set('executionId', executionId)
            .set('seq', String(seq));
        return this.http.get(this.frameUrl, { params, responseType: 'blob' });
    }

    timeline(runner: string, account: string, since: string): Observable<HttpResponse<IObserverTimeline>> {
        let params = new HttpParams().set('runner', runner).set('account', account);
        if (since) {
            params = params.set('since', since);
        }
        return this.http.get<IObserverTimeline>(this.resourceUrl, { params, observe: 'response' });
    }
}
